module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-title",
    attrs: {
      "id": "P1"
    }
  }, [_c('span', {
    staticClass: "part-num"
  }, [_vm._v("PART 1")]), _c('br'), _vm._v("READY, SET, PREP")]), _vm._v(" "), _c('p', {
    staticClass: "intro1"
  }, [_vm._v("When thinking about organic meals, begin with your goal in mind: Ultimately, you want to raise a child who prefers a beautiful green leafy salad with a bowl of fresh fruit and yogurt rather than one who only prefers cupcakes and potato chips. And, you want to ensure that your child is getting a good amount of antioxidants (to help fight illness and disease), nutrients, and fats needed to support healthy development and growth. In this section, you will learn about organic food production, why choosing organic foods is important, and how to stock your kitchen so that you can make the recipes in this book and get creative in the kitchen with your little one.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d0af0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part1.vue
// module id = 78
// module chunks = 0